import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Gauge, ArrowsClockwise } from '@phosphor-icons/react';

export default function TelemetryPanel({
    connectionMode, isHardwareConnected, telemetry,
    telemetryInterval, startTelemetry,
}) {
    return (
        <Card className="glass-card">
            <CardContent className="p-6">
                <div className="text-center mb-4">
                    <Gauge size={48} className="text-primary mx-auto mb-2" />
                    <h3 className="font-display text-lg">Real-Time Telemetry</h3>
                    <p className="text-sm text-muted-foreground">
                        {connectionMode
                            ? `Streaming from ${isHardwareConnected ? 'hardware' : 'simulation'}...`
                            : 'Connect a controller to view live data'}
                    </p>
                </div>

                <Button onClick={startTelemetry}
                    className={`w-full font-display ${telemetryInterval ? 'bg-destructive text-white' : 'bg-primary text-black'}`}
                    data-testid="toggle-telemetry-btn"
                    disabled={!connectionMode}>
                    <ArrowsClockwise size={16} className={`mr-2 ${telemetryInterval ? 'animate-spin' : ''}`} />
                    {telemetryInterval ? 'Stop Telemetry' : 'Start Telemetry Stream'}
                </Button>

                {telemetry && (
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-6">
                        {[
                            { label: 'Voltage', val: `${telemetry.voltage}V`, color: 'text-boltz-gold' },
                            { label: 'Current', val: `${telemetry.current}A`, color: 'text-primary' },
                            { label: 'RPM', val: telemetry.rpm, color: 'text-electric-blue' },
                            { label: 'Speed', val: `${telemetry.speed_kmh} km/h`, color: 'text-cyber-purple' },
                            { label: 'Motor Temp', val: `${telemetry.temperature?.motor}°C`, color: 'text-plasma-red' },
                            { label: 'Ctrl Temp', val: `${telemetry.temperature?.controller}°C`, color: 'text-boltz-gold' },
                        ].map(m => (
                            <div key={m.label} className="p-3 rounded-xl bg-white/5 border border-white/5 text-center" data-testid={`telemetry-${m.label.toLowerCase().replace(/\s/g, '-')}`}>
                                <p className="text-[10px] text-muted-foreground font-display">{m.label}</p>
                                <p className={`text-lg font-black font-mono ${m.color}`}>{m.val}</p>
                            </div>
                        ))}
                    </div>
                )}

                {!connectionMode && (
                    <p className="text-xs text-muted-foreground text-center mt-4">
                        Go to the Connect tab and connect your controller first
                    </p>
                )}
            </CardContent>
        </Card>
    );
}
